export default {"src":"/_next/static/media/ModalCloseIcon.e5cd0fee.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};